import React from 'react';
import { Card, Pill } from './ui';
import { fmtMonthYear } from '../../lib/leagueHelpers';

export default function LeagueMatchweeks({ data }) {
  const rounds = [...(data?.rounds || [])].sort((a, b) => (Number(a?.name) || 0) - (Number(b?.name) || 0));
  const current = rounds.find((r) => r?.is_current);
  return (
    <Card title={`Matchweeks (${rounds.length})`}>
      {(Array.isArray(rounds) ? rounds : []).map((r, i) => {
        const isCurrent = r?.id === current?.id || r?.is_current;
        const finished = r?.finished;
        return (
          <div key={r?.id ?? i} className="i-row">
            <span className="i-mute">Round {r?.name || i + 1}</span>
            <span className="i-fg text-right text-sm">
              {fmtMonthYear(r?.starting_at)} – {fmtMonthYear(r?.ending_at)}{' '}
              {finished ? <Pill className="i-bd">Finished</Pill> : isCurrent ? <Pill className="i-pos-def">Current</Pill> : <Pill>Upcoming</Pill>}
            </span>
          </div>
        );
      })}
      {!rounds.length && <p className="i-dim text-xs">No matchweek data.</p>}
    </Card>
  );
}
